import Cookies from 'js-cookie';
import logger from '../datadog/datadog';

const Session = {
  // Session Cookie Expiration set to 1 Day; User Idle Session timeout of 30 min. overrides this
  EXPIRES: 1,

  destroy: function () {
    // User Logout or Session is invalid - Terminate Session & Destroy cookie
    Cookies.remove('session');
  },

  expired: function (redirectURL) {
    // User Session Expired - this.destroy() + Redirect User Home => Central Auth
    Session.destroy();
    location.href = redirectURL;
  },

  get: function () {
    // User Actions - Return Session & User Info
    const value = Cookies.get('session');
    if (!value) return {};
    try {
      return JSON.parse(value);
    } catch (e) {
      logger.logError('Failed to parse session cookie json', { value, error: e.message });
      return {};
    }
  },

  set: function (id, profile, authState, token) {
    // User Login Authentication - Store Info in Session
    Session.update(id, profile, authState, token);
    Cookies.set('cl-token', token, { domain: '.mapnwea.org' });
  },

  update: function (id, profile, authState, token) {
    try {
      let sessionObj = {
        authState: authState,
        user: {
          profile: profile,
          token: token,
        },
      };

      Cookies.set('session', JSON.stringify(sessionObj), { expires: Session['EXPIRES'], sameSite: 'lax' });
      Cookies.set('cl-token', token, { domain: '.mapnwea.org' });
    } catch (err) {}
  },
};

export default Session;
